export default function AuthorityAcelera() {
  const solutions = [
    {
      icon: 'ri-advertisement-line',
      title: 'Tráfego Pago Inteligente',
      description: 'Campanhas otimizadas com IA para máximo ROI e conversões qualificadas.',
      features: ['Google Ads', 'Facebook Ads', 'LinkedIn Ads', 'Otimização por IA'],
      color: 'green'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'CRM & Automação',
      description: 'Gestão completa de leads com automações que nutrem e convertem.',
      features: ['Pipeline Automatizado', 'Lead Scoring', 'Follow-up Inteligente', 'Relatórios Avançados'],
      color: 'red'
    },
    {
      icon: 'ri-robot-line',
      title: 'Agentes de IA',
      description: 'Assistentes virtuais que qualificam leads e agendam reuniões 24/7.',
      features: ['Chatbots Inteligentes', 'Qualificação Automática', 'Agendamento', 'Integração WhatsApp'],
      color: 'yellow'
    },
    {
      icon: 'ri-whatsapp-line',
      title: 'WhatsApp API',
      description: 'Automações completas no WhatsApp para vendas e atendimento.',
      features: ['Mensagens Automáticas', 'Catálogo Digital', 'Pagamentos', 'Suporte 24h'],
      color: 'green'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Lançamentos Estratégicos',
      description: 'Estratégias completas para lançamento de produtos e serviços.',
      features: ['Planejamento Completo', 'Funis de Conversão', 'Campanhas Integradas', 'Análise de Resultados'],
      color: 'orange'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Reativação de Leads',
      description: 'Recupere leads dormentes com estratégias personalizadas.',
      features: ['Segmentação Avançada', 'Campanhas Personalizadas', 'Ofertas Especiais', 'Remarketing'],
      color: 'red'
    }
  ];

  const getColorClasses = (color: string) => {
    const colors = {
      orange: 'bg-orange-100 text-orange-600',
      red: 'bg-red-100 text-red-600',
      yellow: 'bg-yellow-100 text-yellow-600',
      green: 'bg-green-100 text-green-600'
    };
    return colors[color as keyof typeof colors] || colors.orange;
  };

  return (
    <section className="py-24 lg:py-32 bg-gray-50">
      <div className="container">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-20">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-slate-900 mb-4">
              A M4 Digital estrutura o marketing da sua empresa com soluções feitas sob medida
            </h2>
            <p className="text-lg sm:text-xl text-gray-600 max-w-4xl mx-auto">
              Conheça todos os serviços que oferecemos para que sua empresa tenha mais resultados
            </p>
          </div>
          
          {/* Solutions Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {solutions.map((solution, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm hover:shadow-lg transition-all duration-300"
              >
                <div className={`w-16 h-16 rounded-xl flex items-center justify-center mb-6 transition-all duration-300 ${getColorClasses(solution.color)}`}>
                  <i className={`${solution.icon} text-2xl`}></i>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  {solution.title}
                </h3>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {solution.description}
                </p>
                
                <ul className="space-y-2">
                  {solution.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center gap-2 text-sm text-gray-600">
                      <i className="ri-check-line text-orange-500"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
